import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./MessageCodes.css";
import { X } from "lucide-react";

const A1IMG = (props) => {
  const [showImage, setShowImage] = useState(false);
  const [onClick, setOnClick] = useState(false);

  const dataObj = props.item.data ? JSON.parse(props.item.data) : {};
  const imageUrl = dataObj?.url;

  // Fullscreen popup content
  const popupContent = (
    <div className="fullscreen-overlay">
      <div className="fullscreen-img-wrapper">
        
        <img style={{width : '100%'}} src={imageUrl} alt="Full View" className="fullscreen-img" />

        {/* Close Button */}
        <button
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "white",
            fontSize: "24px",
          }}
          onClick={() => setShowImage(false)}
        >
          <X size={28} />
        </button>
      </div>
    </div>
  );

  return (
    <>
      {/* 60x60 Thumbnail Image */}
      <img
        src={imageUrl}
        alt="thumbnail"
        style={{ width: 200, height: 200 }} 
        className="thumbnail-img"
        onClick={() => {
            if (!props.disable) {
              setShowImage(true);
            }
          }}
      />

      {showImage &&
        ReactDOM.createPortal(popupContent, document.body)}
    </>
  );
};

export default A1IMG;
